// extracted by mini-css-extract-plugin
export default {"bodyBackground":"styles_bodyBackground__H2GSU","dark":"styles_dark__p6Tl3"};